export const REACT_APP_BASE_URL =
'https://api.uepviewer.com/';

export const ENCRYPT_KEY = 'uEpViEWeR@1234!#$%&*';
